import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=bdbf0af6&scoped=true&"
import script from "./Forms.vue?vue&type=script&lang=js&"
export * from "./Forms.vue?vue&type=script&lang=js&"
import style0 from "./Forms.vue?vue&type=style&index=0&id=bdbf0af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbf0af6",
  null
  
)

export default component.exports